import React, { Component } from 'react';
import { connect } from "react-redux";
import {
  Form,
  Input,
  Modal,
  Button,
  Select,
  Upload,
  Icon,
  Radio,
} from "antd"
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  ActionSendFeedback
} from 'appRedux/actions/System/Feedback'

const { Option } = Select
const normFile = e => {
  console.log('Upload event:', e);
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

class Feedback extends Component {
  state = {
    feedback_visible: false,
    FileList: [],
    content: '',
    isMobile: false,
  }

  componentDidMount() {
    //const {filterSurveysByTag, db_project} = this.props
    this.widthReset();
    // filterSurveysByTag([],db_project.id);

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = e => {
    if (e.target.innerWidth >= 768) {
      this.setState({
        isMobile: false
      })
    } else {
      this.setState({
        isMobile: true
      })
    }
  }

  widthReset() {
    if (window.innerWidth >= 768) {
      this.setState({
        isMobile: false
      })
    } else {
      this.setState({
        isMobile: true
      })
    }
  }  

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.feedback_visible !== prevState.feedback_visible) {
      this.setState({
        content: '',
        FileList: [],
      })
      this.props.form.setFieldsValue({
        file: [],
      })
    }
    if (prevState.content !== this.state.content) {
      this.props.form.setFieldsValue({
        content: this.state.content
      })
    }
  }

  handleFeedbackOpen = () => {
    this.setState({
      feedback_visible: true
    })
  }

  handleFeedbackClose = () => {
    const { form } = this.props
    form.resetFields();
    this.setState({
      feedback_visible: false,
      fileList: []
    })
  }

  handleFeedbackSubmit = () => {
    const { form, ActionSendFeedback } = this.props
    form.validateFields((err, values) => {

      if (err) {
        return;
      }

      ActionSendFeedback(values);

      form.resetFields();
      this.setState({ feedback_visible: false });
    });
  }

  render() {
    const { form } = this.props
    const { getFieldDecorator } = form;
    const { isMobile } = this.state;
    const props = {
      name: 'file',
      beforeUpload: file => {
        this.setState({
          FileList: [...this.state.FileList, file]
        })
        return false
      },
      onRemove: file => {
        let file_arr = this.state.FileList
        let index = file_arr.indexOf(file)
        if (index > -1) {
          file_arr.splice(index, 1)
        }
        this.setState({
          FileList: file_arr
        })
        this.props.form.setFieldsValue({
          file: file_arr
        })
      },
      fileList: this.state.FileList,
    };

    return (
      <div>
        {
          !isMobile ?
          <Button style={{marginBottom: 0}} onClick={this.handleFeedbackOpen}>Send Feedback</Button> :
          <Button type="default" icon="mail" className="remove-padding remove-margin-b remove-margin-r" title="Send Feedback" size="small" onClick={this.handleFeedbackOpen}/>
        }
        
        <Modal
          visible={this.state.feedback_visible}
          onCancel={this.handleFeedbackClose}
          onOk={this.handleFeedbackSubmit}
          okText={"Submit"}
          title="Send feedback"
        >
          <Form layout="vertical">
            <Form.Item label="Type" hasFeedback>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: 'Please select a type!' }],
              })(
                <Select placeholder="Please select a type">
                  <Option value="Bug">Bug</Option>
                  <Option value="Suggestion">Suggestion</Option>
                  <Option value="Question">Question</Option>
                </Select>
              )}
            </Form.Item>

            <Form.Item label="Description">
              <p>Please include as much detail as you can, such as the client and/or assessment name, the activities you were doing or any error messages you saw.</p>
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Please enter the description.',
                  }
                ],
                valuePropName: 'data',

                getValueFromEvent: (event, editor) => {
                  const data = editor.getData();
                  return data;
                },
                initialValue: ''
              })(<CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: ['heading', '|', 'bold', 'italic', 'blockQuote', 'link', 'numberedList', 'bulletedList', 'insertTable',
                    'tableColumn', 'tableRow', 'mergeTableCells', '|', 'undo', 'redo']
                }}
                onChange={this.handleCKChange}
              />)}
            </Form.Item>

            <Form.Item label="Add Attachments" valuePropName='fileList'>
              {
                getFieldDecorator('file', {

                  getValueFromEvent: normFile,
                  rules: [{
                    required: false,
                    message: 'Please choose a file'
                  }]
                })(
                  <Upload {...props} >
                    <Button style={{ width: '100%' }}>
                      <Icon type="upload" />
                    </Button>
                  </Upload>
                )
              }
            </Form.Item>

            <Form.Item label="Your name">
              {getFieldDecorator('name', {
                rules: [{ required: true, message: 'Please input your name!' }],
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item label="Your email address">
              {getFieldDecorator('email', {
                rules: [{
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },{ required: true, message: 'Please input your email!' }],
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item label="Can we contact you regarding this feedback?">
              {getFieldDecorator('contact', {
                rules: [{ required: true, message: 'Please select!' }],
              })(
                <Radio.Group >
                  <Radio value={'Yes'}>Yes</Radio>
                  <Radio value={'No'}>No</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ assessments }) => {

  const {
    survey_description
  } = assessments.assessments_ui;

  return {
    survey_description
  }
};
const WerappedFeedback = Form.create({ name: 'feedbackform' })(Feedback);
export default connect(mapStateToProps, {
  ActionSendFeedback
})(WerappedFeedback);